<template lang="html">
  <div id="product-detail-page" data-aos="fade">
    <section class="container main-section">
      <div class="row">
        <div class="col-12 col-info">
          <h2 class="mb-3 title-s1">Acabado espejo</h2>
        </div>

        <div class="col-lg-5 col-gallery">
          <div class="box-gallery">
            <img src="public/images/pages/products/product-2-xl.jpg">
          </div>
        </div>

        <div class="col-lg-7 col-info">
          <!-- <h2 class="mb-3 title-s1">Tira de exhibidora de impulso</h2> -->

          <div class="mt-4 box-table">
            <h5 class="table-title">Caracteristicas del Producto</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <tbody>
                  <tr>
                    <td class="bg-2">Disponible en translucido, media opacidad y total opacidad y colores.</td>
                  </tr>
                  <tr>
                    <td class="bg-1">Superficies matte, brillo, translúcido,diagonales.</td>
                  </tr>
                  <tr>
                    <td class="bg-2">Fabricación y corte de hojas a la medida.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mt-5 box-table">
            <h5 class="table-title">Aplicaciones Típicas</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <tbody>
                  <tr>
                    <td class="bg-2">Impresión, impresión termoformado.</td>
                  </tr>
                  <tr>
                    <td class="bg-1">Suajado.</td>
                  </tr>
                  <tr>
                    <td class="bg-2">Tiraje de Impulso. P.O.P.</td>
                  </tr>
                  <tr>
                    <td class="bg-1">Aplicaciones Automotrices.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <p class="p-md mt-3 text-justify">
            Estos valores son típicos y representan un promedio sobre las pruebas y los muestreos realizados en muestra naturales usando procedimientos de uso común así como datos proporcionados por nuestros proveedores, estos datos. Se dan sin garantía, ya que es creíble y obtenida de fuentes creibles y exactas para procesos plásticos laminados.
          </p>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
}
</script>
